// src/App.tsx

import React from "react";
import "./themes.css"; // Theme CSS variables — must load before App.css
import "./App.css"; // Import the App.css stylesheet
import "@fortawesome/fontawesome-free/css/all.min.css";

import { CartProvider } from "./contexts/CartContext";
import { WishlistProvider } from "./contexts/WishlistContext";
import MainPage from "./pages/MainPage";
import CookieConsent from "./components/CookieConsent";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SearchProvider } from "./contexts/SearchContext";
import { SelectedLocationProvider } from "./contexts/SelectedLocationContext";
import { HamburgerMenuProvider } from "./contexts/HamburgerMenuContext";
import { PaymentProvider } from "./contexts/PaymentContext";
import { FeatureToggleProvider } from "./contexts/FeatureToggleContext";
import { CatalogProvider } from "./contexts/CatalogContext";
import { SiteConfigProvider } from "./contexts/SiteConfigContext";
import { CustomerAuthProvider } from "./contexts/CustomerAuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <SelectedLocationProvider>
        <SearchProvider>
          <HamburgerMenuProvider>
            <SiteConfigProvider>
              <CatalogProvider>
                <CartProvider>
                  <WishlistProvider>
                    <PaymentProvider>
                      <FeatureToggleProvider>
                        <CustomerAuthProvider>
                          <BrowserRouter>
                            <Routes>
                              <Route path="/*" element={<MainPage />} />
                            </Routes>
                            <CookieConsent />
                          </BrowserRouter>
                        </CustomerAuthProvider>
                      </FeatureToggleProvider>
                    </PaymentProvider>
                  </WishlistProvider>
                </CartProvider>
              </CatalogProvider>
            </SiteConfigProvider>
          </HamburgerMenuProvider>
        </SearchProvider>
      </SelectedLocationProvider>
    </ThemeProvider>
  );
};

export default App;
